class ClientUserPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'client_user.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'client_user._m';

    // Scope: all clients across all workspaces
    static ACCESS_SCOPE_ALL = 'client_user.access.scope.all';

    // Scope: only clients withing same workspace
    static ACCESS_SCOPE_WORKSPACE = 'client_user.access.scope.workspace';

    // Scope: only self if caller has 'client' type
    static ACCESS_SCOPE_SELF = 'client_user.access.scope.self';

    // Can access unverified users
    static ACCESS_UNVERIFIED = 'client_user.access.unverified';

    // Can access shutdown users
    static ACCESS_SHUTDOWN = 'client_user.access.shutdown';

    // Can create new clients
    static CREATE = 'client_user.create';

    // Can update main client info
    static INFO_UPDATE = 'client_user.info.update';

    // Can manually update client email
    static EMAIL_UPDATE_MANUAL = 'client_user.email.update.manual';

    // Can use UserEmailChange flow to update email
    static EMAIL_UPDATE_FLOW = 'client_user.email.update.flow';

    // Can manually manage client verification status
    static VERIFICATION_MANAGE = 'client_user.verification.manage';

    // Can initiate and use user verification flow
    static VERIFICATION_FLOW = 'client_user.verification.flow';

    // Can shut down client
    static SHUTDOWN = 'client_user.shutdown';

    // Can set up Google auth
    static AUTH_GOOGLE_SETUP = 'client_user.auth.google.setup';

    // Can remove Google auth
    static AUTH_GOOGLE_REMOVE = 'client_user.auth.google.remove';

    // Can set up password auth
    static AUTH_PASSWORD_SETUP = 'client_user.auth.password.setup';

    // Can remove password auth
    static AUTH_PASSWORD_REMOVE = 'client_user.auth.password.remove';

    // Can update password with confirmation
    static AUTH_PASSWORD_UPDATE = 'client_user.auth.password.update';

    // Can manually apply new password without confirmation
    static AUTH_PASSWORD_UPDATE_FORCED = 'client_user.auth.password.update.forced';

    // Can manage auth role of user
    static AUTH_ROLE_MANAGE = 'client_user.auth_role.manage';
}

export default ClientUserPermission;
